module.exports = __webpack_public_path__ + "static/img/19090D_1_R_20201022_LC.b52089c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19090D_1_R_20201022_LC.png
// module id = St6j
// module chunks = 0